import { Button } from '@components/ui/Button';
import Box from '@components/ui/layout/Box';
import { Text } from '@components/ui/typography';
import { parse } from '@config/theme';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { FC, useEffect } from 'react';
type BlogPaginationProps = {
  current: number;
  total: number;
  perPage: number;
};
export const BlogPagination: FC<BlogPaginationProps> = ({
  current,
  total,
  perPage
}) => {
  const {
    push,
    prefetch
  } = useRouter();
  const hasPrev = current > 0;
  const hasNext = (current + 1) * perPage < total;
  const pages = Math.ceil(total / perPage);
  useEffect(() => {
    if (pages > 1) {
      prefetch(`/blog/page/${current}`);
      prefetch(`/blog/page/${current + 2}`);
    }
  }, [prefetch, pages, current]);
  if (pages === 1) {
    return null;
  }
  let links = [];
  for (let page = 0; page < pages; page++) {
    links.push(<Link href={`/blog/page/${page + 1}`} passHref key={page} legacyBehavior>
        <Text as="a" variant="buttonLabelRegular" color="shade800" className={link} data-active={current === page ? '' : undefined}>
          {page + 1}
        </Text>
      </Link>);
  }
  return <div className={grid}>
      <div>
        <Button variant="standard" disabled={!hasPrev} onClick={() => push(`/blog/page/${current}`)} title="Go to previous page">
          Prev
        </Button>
      </div>
      <div className={linksContainer}>{links}</div>
      <Box display="flex" justifyContent="flex-end">
        <Button variant="gradient" disabled={!hasNext} onClick={() => push(`/blog/page/${current + 2}`)} title="Go to next page">
          Next
        </Button>
      </Box>
    </div>;
};
const grid = parse({
  display: 'grid',
  alignItems: 'center',
  mb: {
    _: '104'
  },
  justifyContent: 'center'
}, "g1stw7nx");
const linksContainer = parse({
  display: 'flex',
  justifyContent: 'center'
});
const link = parse({
  mx: '2'
}, "llyuddk");

require("./Pagination.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Pagination.tsx");